import React from 'react';
import theme from '@/constants/theme';
import Textarea from '@/components/input/Textarea';
import { MarkdownReader } from '@/components/dataDisplay/MarkdownReader';
import {
  ChoiceQuestion,
  isChoiceQuestion,
  Question as QuestionType,
  RangeQuestion,
  Response,
} from '../../common';
import QuestionOptions from './QuestionOptions';
import RangeSelector from './QuestionOptions/RangeSelector';

interface Props {
  id: QuestionType['id'];
  type: QuestionType['type'];
  question: QuestionType['question'];
  options?: QuestionType['options'];
  config?: QuestionType['config'];
  response?: Response['answer'];
  onChangeResponse?: (response: Response['answer']) => void;
}

const Question: React.FC<Props> = ({ id, type, question, options, response, config, onChangeResponse }) => {
  return (
    <div style={styles.container}>
      {!(['text'] as QuestionType['type'][]).includes(type) && (
        <h4 style={{ color: theme.colors.text.title, fontWeight: 'normal' }}>{question}</h4>
      )}
      {(['text'] as QuestionType['type'][]).includes(type) && question && (
        <div>
          {/* <p style={{ color: theme.colors.text.body, lineHeight: 1.5 }}>{question}</p> */}
          <MarkdownReader>{question}</MarkdownReader>
        </div>
      )}
      {(['open'] as QuestionType['type'][]).includes(type) && (
        <Textarea
          sx={{ minHeight: 80, width: '100%', height: 36, backgroundColor: '#ffffff10' }}
          value={response ?? ''}
          onChange={(evt) => onChangeResponse?.(evt.target.value)}
        />
      )}
      {type === 'range' && (
        <RangeSelector
          value={response as string}
          onChangeResponse={onChangeResponse}
          options={options as RangeQuestion['options']}
        />
      )}

      {isChoiceQuestion(type) && (
        <QuestionOptions
          type={type}
          questionId={id}
          options={options as ChoiceQuestion['options']}
          response={response}
          onChangeResponse={onChangeResponse}
          config={config}
        />
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    color: theme.colors.text.body,
    backgroundColor: theme.colors.background.secondary,
    borderRadius: 16,
    padding: 20,
  },
  listIndicator: {
    position: 'relative',
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.colors.text.caption,
  },
};

export default Question;
